// ============================================
// CART REWARD BAR — drawer, main cart, product page
// Free Delivery: Rs.3000 | 10% Off: Rs.9999
// ============================================
(function() {
  if (window.__cartRewardBarInit) return;
  window.__cartRewardBarInit = true;

  var FREE_SHIP = 3000;
  var DISCOUNT_THRESHOLD = 9999;
  var DISCOUNT_RATE = 0.10;
  var CART_URL_PATTERN = /\/cart\/(change|add|update)/;

  function resolveCart(source) {
    if (source && source.detail && source.detail.cart) {
      return Promise.resolve(source.detail.cart);
    }
    if (source && source.total_price !== undefined) {
      return Promise.resolve(source);
    }
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function formatRs(amount) {
    return 'Rs.' + Math.round(amount).toLocaleString('en-US');
  }

  function remainingRs(amount) {
    return String(Math.max(0, Math.ceil(amount)));
  }

  function normalizeMsg(text) {
    return String(text || '')
      .replace(/(\d+)\.0+\b/g, '$1')
      .replace(/,/g, '')
      .trim();
  }

  function getFillProgress(fill, visual) {
    if (!fill) return null;
    if (visual) {
      var css = parseFloat(getComputedStyle(fill).getPropertyValue('--crb-progress'));
      if (!isNaN(css)) return css * 100;
    }
    var attr = parseFloat(fill.getAttribute('data-crb-progress'));
    if (!isNaN(attr)) return attr;
    var fallback = parseFloat(getComputedStyle(fill).getPropertyValue('--crb-progress'));
    if (!isNaN(fallback)) return fallback * 100;
    return null;
  }

  var lastProgress = null;
  var playLockUntil = 0;

  function snapshotBar() {
    var fill = document.querySelector('[data-cart-reward-bar] .crb-final__bar-fill');
    var pct = getFillProgress(fill, true);
    if (pct != null && !isNaN(pct)) lastProgress = pct;
    return lastProgress;
  }

  function setFillProgress(fill, pct, immediate) {
    if (!fill) return;
    var value = Math.max(0, Math.min(100, pct)) / 100;
    if (immediate) {
      fill.classList.add('crb-final__bar-fill--no-anim');
      fill.style.setProperty('--crb-progress', String(value));
      void fill.offsetWidth;
      fill.classList.remove('crb-final__bar-fill--no-anim');
      return;
    }
    fill.style.setProperty('--crb-progress', String(value));
  }

  function playFill(fromPct) {
    if (Date.now() < playLockUntil) return;

    var fills = document.querySelectorAll('[data-cart-reward-bar] .crb-final__bar-fill');
    if (!fills.length) return;

    playLockUntil = Date.now() + 750;

    fills.forEach(function (fill) {
      var target = getFillProgress(fill);
      if (target == null || isNaN(target)) return;
      var from = fromPct != null && !isNaN(fromPct) ? fromPct : lastProgress;

      if (from == null || isNaN(from) || Math.abs(from - target) < 0.15) {
        setFillProgress(fill, target, true);
        lastProgress = target;
        return;
      }

      setFillProgress(fill, from, true);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setFillProgress(fill, target, false);
          lastProgress = target;
        });
      });
    });
  }

  function animateFill(fill, progress) {
    if (!fill) return;
    var target = Math.max(0, Math.min(100, progress));
    fill.setAttribute('data-crb-progress', String(target));

    if (Date.now() < playLockUntil) {
      setFillProgress(fill, target, false);
      lastProgress = target;
      return;
    }

    var shown = parseFloat(getComputedStyle(fill).getPropertyValue('--crb-progress')) * 100;
    var from = lastProgress != null ? lastProgress : shown;

    if (from != null && !isNaN(from) && Math.abs(from - target) > 0.15) {
      if (isNaN(shown) || Math.abs(shown - target) < 0.15) {
        playFill(from);
        lastProgress = target;
        return;
      }
      setFillProgress(fill, target, false);
    } else {
      setFillProgress(fill, target, false);
    }

    lastProgress = target;
  }

  // --- Reward bar ---
  function applyBarUpdate(bar, total, qty, freeDelivered, discountUnlocked, progress, msg) {
    var msgEl = bar.querySelector('.crb-final__msg');
    if (msgEl && normalizeMsg(msgEl.textContent) !== normalizeMsg(msg)) {
      msgEl.textContent = msg;
    }

    animateFill(bar.querySelector('.crb-final__bar-fill'), progress);

    var iconCircles = bar.querySelectorAll('.crb-final__icon-circle');
    if (iconCircles.length >= 2) {
      iconCircles[0].classList.toggle('crb-final__icon-circle--active', freeDelivered);
      iconCircles[1].classList.toggle('crb-final__icon-circle--active', discountUnlocked);
    }

    var labelStops = bar.querySelectorAll('.crb-final__label-stop');
    if (labelStops.length >= 2) {
      var labels0 = labelStops[0].querySelectorAll('.crb-final__milestone-label, .crb-final__milestone-price');
      var labels1 = labelStops[1].querySelectorAll('.crb-final__milestone-label, .crb-final__milestone-price');
      labels0.forEach(function(el) {
        el.classList.toggle('crb-final__milestone-label--active', freeDelivered && el.classList.contains('crb-final__milestone-label'));
        el.classList.toggle('crb-final__milestone-price--active', freeDelivered && el.classList.contains('crb-final__milestone-price'));
      });
      labels1.forEach(function(el) {
        el.classList.toggle('crb-final__milestone-label--active', discountUnlocked && el.classList.contains('crb-final__milestone-label'));
        el.classList.toggle('crb-final__milestone-price--active', discountUnlocked && el.classList.contains('crb-final__milestone-price'));
      });
    }
  }

  function applyBarFromCart(cart) {
    var total = cart.original_total_price / 100;
    var qty = cart.item_count;
    var freeDelivered = total >= FREE_SHIP;
    var discountUnlocked = total >= DISCOUNT_THRESHOLD;

    var progress = (total / DISCOUNT_THRESHOLD) * 100;
    if (progress > 100) progress = 100;
    if (progress < 0) progress = 0;

    var msg = '';
    if (discountUnlocked) {
      msg = 'Congratulations! You unlocked 10% off';
    } else if (freeDelivered) {
      msg = 'Free Delivery unlocked — Add Rs.' + remainingRs(DISCOUNT_THRESHOLD - total) + ' more for 10% Off';
    } else {
      var rem = remainingRs(FREE_SHIP - total);
      msg = (total > 0 && qty > 0)
        ? 'Add Rs.' + rem + ' more for Free Delivery'
        : 'Add items to unlock Free Delivery & 10% Off';
    }

    document.querySelectorAll('[data-cart-reward-bar]').forEach(function(bar) {
      applyBarUpdate(bar, total, qty, freeDelivered, discountUnlocked, progress, msg);
    });
  }

  // --- Subtotal ---
  function applySubtotalToEl(subtotalEl, cart) {
    var total = cart.total_price / 100;
    var originalTotal = cart.original_total_price / 100;
    var totalDiscount = cart.total_discount / 100;

    if (totalDiscount > 0) {
      var orig = Math.round(originalTotal * 100) / 100;
      var fin = Math.round(total * 100) / 100;
      var saved = Math.round(totalDiscount * 100) / 100;
      subtotalEl.innerHTML =
        '<span style="text-decoration:line-through;color:#8a9aa8;font-size:0.85em;margin-right:6px">' + formatRs(orig) + '</span>' +
        '<span style="color:#2b6b3e;font-weight:600">' + formatRs(fin) + '</span>' +
        '<div style="font-size:11px;color:#2b6b3e;margin-top:2px;font-weight:500">Save ' + formatRs(saved) + '</div>';
      return;
    }

    if (total >= DISCOUNT_THRESHOLD) {
      var discounted = originalTotal * (1 - DISCOUNT_RATE);
      var origShow = Math.round(originalTotal * 100) / 100;
      var dispShow = Math.round(discounted * 100) / 100;
      var saveShow = Math.round((originalTotal - discounted) * 100) / 100;
      subtotalEl.innerHTML =
        '<span style="text-decoration:line-through;color:#8a9aa8;font-size:0.85em;margin-right:6px">' + formatRs(origShow) + '</span>' +
        '<span style="color:#2b6b3e;font-weight:600">' + formatRs(dispShow) + '</span>' +
        '<div style="font-size:11px;color:#2b6b3e;margin-top:2px;font-weight:500">Save ' + formatRs(saveShow) + ' (10%)</div>';
    } else {
      subtotalEl.textContent = formatRs(total);
    }
  }

  // --- Discount row (fixes sticky discount after delete) ---
  function updateDiscountContainer(container, cart) {
    var total = cart.total_price / 100;
    var originalTotal = cart.original_total_price / 100;
    var totalDiscount = cart.total_discount / 100;
    var showDiscount = totalDiscount > 0 || total >= DISCOUNT_THRESHOLD;

    if (!showDiscount) {
      container.style.display = 'none';
      container.innerHTML = '';
      return;
    }

    container.style.display = '';

    var discountAmount = totalDiscount > 0
      ? Math.round(totalDiscount * 100) / 100
      : Math.round(originalTotal * DISCOUNT_RATE * 100) / 100;

    var discountText = 'Discount 10% (-' + formatRs(discountAmount) + ')';
    var row = container.querySelector('.cart__discounts');

    if (row) {
      row.style.display = '';
      var valueEl = row.querySelector('.cart__discount');
      if (valueEl) {
        valueEl.textContent = discountText;
        valueEl.style.display = '';
      }
      return;
    }

    container.innerHTML =
      '<div class="cart__discounts cart__item-sub cart__item-row">' +
        '<div>Discounts</div>' +
        '<div class="text-right"><div class="cart__discount">' + discountText + '</div></div>' +
      '</div>';
  }

  function applyDiscountFromCart(cart) {
    document.querySelectorAll('[data-subtotal]').forEach(function(el) {
      applySubtotalToEl(el, cart);
    });

    document.querySelectorAll('[data-discounts]').forEach(function(container) {
      updateDiscountContainer(container, cart);
    });
  }

  var refreshTimer = null;
  function refresh(source) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      refreshTimer = null;
      resolveCart(source).then(function(cart) {
        applyBarFromCart(cart);
        applyDiscountFromCart(cart);
      });
    }, 40);
  }

  // Single fetch patch for all cart API calls
  var nativeFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && CART_URL_PATTERN.test(url)) {
      snapshotBar();
    }
    var result = nativeFetch.apply(this, arguments);
    if (typeof url === 'string' && CART_URL_PATTERN.test(url)) {
      result.then(function() {
        setTimeout(refresh, 0);
      });
    }
    return result;
  };

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('product-form:cart:update', refresh);

  document.addEventListener('pointerdown', function(e) {
    var qtyBtn = e.target.closest('.cart-drawer .quantity__button');
    if (!qtyBtn) return;
    qtyBtn.classList.add('is-pressed');
    setTimeout(function() { qtyBtn.classList.remove('is-pressed'); }, 180);
  });

  // Re-apply when theme.js overwrites subtotal after AJAX rebuild
  var lastSubtotalText = '';
  var observer = new MutationObserver(function (mutations) {
    var addedFill = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.crb-final__bar-fill')) addedFill = true;
        if (node.querySelector && node.querySelector('.crb-final__bar-fill')) addedFill = true;
      });
    });

    if (addedFill) playFill(lastProgress);

    var msgEl = document.querySelector('[data-cart-reward-bar] .crb-final__msg');
    if (msgEl && /\d+\.0+\b/.test(msgEl.textContent)) {
      msgEl.textContent = msgEl.textContent.replace(/(\d+)\.0+\b/g, '$1');
    }

    var el = document.querySelector('[data-subtotal]');
    if (el && el.textContent !== lastSubtotalText) {
      lastSubtotalText = el.textContent;
      if (el.children.length === 0) {
        refresh();
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // --- Trash / remove button (drawer + main cart) ---
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart__remove-btn');
    if (!btn) return;

    var key = btn.getAttribute('data-key');
    if (!key) return;

    e.preventDefault();

    var cartItem = btn.closest('.cart__item, .cart-item, [data-cart-item]');
    btn.disabled = true;

    if (cartItem) {
      cartItem.classList.add('cart__item-removing');
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Remove failed');
        return res.json();
      })
      .then(function(cart) {
        setTimeout(function() {
          if (cartItem) {
            cartItem.remove();
          }

          document.querySelectorAll('[data-cart-count], .cart-link__bubble-num').forEach(function(el) {
            el.textContent = cart.item_count;
          });

          var bubbles = document.querySelectorAll('.cart-link__bubble');
          bubbles.forEach(function(b) {
            b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
          });

          refresh(cart);

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));

          if (cart.item_count === 0) {
            var drawerForm = document.getElementById('CartDrawerForm');
            if (drawerForm) {
              drawerForm.classList.add('is-empty');
            }
            if (document.body.classList.contains('template-cart')) {
              setTimeout(function() { window.location.reload(); }, 500);
            }
          }
        }, 300);
      })
      .catch(function(err) {
        console.error('Cart remove error:', err);
        btn.disabled = false;
        if (cartItem) {
          cartItem.classList.remove('cart__item-removing');
        }
        alert('Try again');
      });
  });

  window.CartRewardBar = {
    refresh: refresh,
    snapshot: snapshotBar,
    play: playFill
  };

  setTimeout(refresh, 200);
})();